'use strict';
ui.loadTemplateFile('skills.html');

class SkillsDialog extends Dialog {
  _element: any;
  _titleBar: any;
  _basicSkills: any;
  _cartSkills: any;
  _castleGearSkills: any;
  _uniqueSkills1: any;
  _uniqueSkills2: any;
  _uniqueSkills3: any;
  _uniqueSkills4: any;
  _pay2winSkills1: any;
  _pay2winSkills2: any;
  _jobSkills1: any;
  _jobSkills2: any;
  _jobSkills3: any;
  _data: any;

  constructor(skills: any) {
    super('skills.html');

    ui.tabpanel(this, '.tabpanel.basic');
    ui.tabpanel(this, '.tabpanel.category');
    ui.tabpanel(this, '.tabpanel.parts');
    ui.tabpanel(this, '.tabpanel.unique');
    ui.tabpanel(this, '.tabpanel.pay2win');
    ui.tabpanel(this, '.tabpanel.job');

    this._basicSkills = ui.skillpanel(this, '.skill-panel.basic');
    this._cartSkills = ui.skillpanel(this, '.skill-panel.cart');
    this._castleGearSkills = ui.skillpanel(this, '.skill-panel.castle-gear');

    this._uniqueSkills1 = ui.skillpanel(this, '.skill-panel.unique-1');
    this._uniqueSkills2 = ui.skillpanel(this, '.skill-panel.unique-2');
    this._uniqueSkills3 = ui.skillpanel(this, '.skill-panel.unique-3');
    this._uniqueSkills4 = ui.skillpanel(this, '.skill-panel.unique-4');

    this._pay2winSkills1 = ui.skillpanel(this, '.skill-panel.pay-to-win-1');
    this._pay2winSkills2 = ui.skillpanel(this, '.skill-panel.pay-to-win-2');

    this._jobSkills1 = ui.skillpanel(this, '.skill-panel.job-1');
    this._jobSkills2 = ui.skillpanel(this, '.skill-panel.job-2');
    this._jobSkills3 = ui.skillpanel(this, '.skill-panel.job-3');

    this.center();

    this._data = skills;
    this._data.on('changed', this._update.bind(this));
    this._update();

    this._element.on('dragover', (event: any) => event.preventDefault());
    this._element.on('drop', (event: any) => {
      event.preventDefault();
      const skillIdx = event.originalEvent.dataTransfer.getData('text/plain');
      if (skillIdx) {
        netGame.chatSay(`/learnskill ${skillIdx}`);
      }
    });
  }

  _update() {
    // TODO: Put in correct locations
    for (let i = 0; i < this._data.skills.length && i < 42; ++i) {
      this._basicSkills.slots[i].setIcon(HOT_ICON_TYPE.SKILL, this._data.skills[i]);
    }
  }

  _onSwap(slot: any, dst: any) {
    const srcSkill = slot.icon();
    const match = dst.match(/^quick-slot-([0-9]*)$/);

    if (match) {
      const quickbarSlot = match[1];
      netGame.setHotIcon(match[1], HOT_ICON_TYPE.SKILL, srcSkill.slot);
    }
  }
}

ui.SkillsDialog = SkillsDialog;
ui.skillsDialog = (skills: any) => {
  return new ui.SkillsDialog(skills);
};

class SkillPanel extends Widget {
  _element: any;
  slots: any[];

  constructor(element: any) {
    super(element);

    const parent = this.parent('dialog');
    this.slots = [];

    for (let i = 0; i < 42; ++i) {
      const slot = ui.iconslot();
      slot.on('swap', parent._onSwap.bind(parent, slot));
      this.slots.push(slot);
      this.append(slot);
    }
  }

  static Create() {
    return $('<div class="skill-panel" />');
  }
}

ui.SkillPanel = SkillPanel;

ui.skillpanel = ui.widgetConstructor('skill-panel', ui.SkillPanel);
